<section>
    <a id="mail" href="mailto:hdateam90&#64;gmail.com">hdateam90&#64;gmail.com</a>
    <div id="arrow-animation">
        <img [src]="currentImage" class="arrow" alt="Animating arrow" />
        <span id="scroll">Scroll down</span>
    </div>
</section>

